import { toJS } from "mobx";
import AdminStore from "../stores/internal/AdminStore";

export const getAllSites = () => toJS(AdminStore.sites)
export const getAllSubmissions = () => toJS(AdminStore.submissions)
export const getAllProjects = () => toJS(AdminStore.projects);
export const getProjectById = (project_id) => toJS(AdminStore.project[project_id])
